import { ICurrentUser, IUserTokens } from '../currentuser/currentUser';
import { Analytics } from '@segment/analytics-next';
import { AnalyticsEvent } from './AnalyticsEvent';
import { mobileConfig } from '../commons/config';
import { isSmallerThanTablet } from '../responsive/hooks/hooks';
import { addEventToBuffer } from './analyticsBuffer';
import { sendAnalyticsEventDirectly } from './analyticsSender';

export const getStandardCustomProperties = () => {
  const config = mobileConfig();
  return {
    isMobileApp: config.isMobile,
    growegyPlatform: config.growegyMobilePlatform
      ? config.growegyMobilePlatform
      : isSmallerThanTablet()
      ? 'mobile-web'
      : 'web',
  };
};

export const analyticsIdentifyUser = async (
  analytics: Analytics | undefined,
  currentUser: ICurrentUser,
  tokens: IUserTokens | null
) => {
  try {
    analytics?.identify(currentUser.userId, {
      roles: currentUser.roles.map((x) => x.id).join(','),
      ...getStandardCustomProperties(),
    });

    const roles = currentUser.roles.map((x) => x.id).join(',');
    analytics?.track(
      `${AnalyticsEvent.USER_SIGNED_IN.entity} ${AnalyticsEvent.USER_SIGNED_IN.action}`,
      {
        roles,
        ...getStandardCustomProperties(),
      }
    );

    await sendAnalyticsEventDirectly(AnalyticsEvent.USER_SIGNED_IN, { roles }, tokens);
  } catch (err) {
    logger.error('Error while identifying user: ', err);
  }
};

export const analyticsTrack = (
  analytics: Analytics | undefined,
  analyticsEvent: AnalyticsEvent,
  properties: object = {}
) => {
  logger.info(
    `Reporting analytics event: ${analyticsEvent.entity} ${analyticsEvent.action}`,
    properties
  );
  try {
    analytics?.track(`${analyticsEvent.entity} ${analyticsEvent.action}`, {
      ...properties,
      ...getStandardCustomProperties(),
    });
    addEventToBuffer(analyticsEvent, properties);
  } catch (err) {
    logger.error('Error while reporting analytics event: ', err);
  }
};
